import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ECWID_STORE_ID, ECWID_ACCESS_TOKEN } from "../config/EcwidConfig";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `https://app.ecwid.com/api/v3/${ECWID_STORE_ID}/customers?email=${email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${ECWID_ACCESS_TOKEN}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      console.log("Customer details:", data);

      if (data.items && data.items.length > 0) {
        const customer = data.items[0];
        // Check if password exists in localStorage for this email
        const savedPassword = localStorage.getItem(`pw_${email}`);

        // If no password is stored, we should check if this is an existing Ecwid customer
        // who might have signed up outside of our system
        if (!savedPassword) {
          // For existing Ecwid customers without a locally stored password,
          // we'll allow login with any password and store it for future use
          // This is a workaround for customers created outside our signup form

          // Store the entered password for future logins
          localStorage.setItem(`pw_${email}`, password);

          // Clear any existing customer data first
          localStorage.removeItem("customer");
          localStorage.removeItem("customerProfile");
          localStorage.removeItem("customerEmail");

          // Set new customer data
          localStorage.setItem("customer", JSON.stringify(customer));
          localStorage.setItem("customerProfile", JSON.stringify(customer));
          localStorage.setItem("customerEmail", email);
          navigate("/"); // ✅ redirect after login
          return;
        }

        if (password === savedPassword) {
          // Clear any existing customer data first
          localStorage.removeItem("customer");
          localStorage.removeItem("customerProfile");
          localStorage.removeItem("customerEmail");

          // Set new customer data
          localStorage.setItem("customer", JSON.stringify(customer));
          localStorage.setItem("customerProfile", JSON.stringify(customer));
          localStorage.setItem("customerEmail", email);
          navigate("/"); // ✅ redirect after login
        } else {
          setError("Invalid password");
        }
      } else {
        setError("No account found with this email");
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div
      className="flex items-center justify-center p-3 min-h-[550px] bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%"
      style={{
        background: `url('../assets/signup-bg.jpg') no-repeat top right`,
        height: "100vh",
        backgroundSize: "cover",
      }}
    >
      <div className="w-full max-w-md bg-white p-5 rounded-lg ms-0 md:ms-48 shadow-sm border border-gray-300">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Sign In to Your Account
        </h2>

        <form className="space-y-5" onSubmit={handleSignIn}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <div className="flex justify-between text-sm text-gray-600">
            <label>
              <input type="checkbox" className="mr-1" />
              Remember me
            </label>
            <Link
              to="/ForgotPassword"
              className="text-[#82b016] hover:underline"
            >
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full bg-[#82b016] text-white py-2 rounded-md hover:bg-gray-700 transition"
          >
            Sign In
          </button>

          <p className="text-sm text-center text-gray-600 mt-4">
            Don't have an account?{" "}
            <Link to="/SignUp" className="text-[#82b016] hover:underline">
              Sign Up
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
